
export default function ModalBodyAlert({ children }) {
    return <div className="Modal2-body--alert">{children}</div>;
}
